import {
	MarketingPage,
	MarketingSection,
} from './+shared/marketing-page.tsx'
import { type Route } from './+types/privacyverklaring.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Privacyverklaring — Muziekdocent' },
	{
		name: 'description',
		content:
			'Hoe Muziekdocent omgaat met persoonsgegevens van scholen, docenten en leerlingen. EU-hosting, geen tracking, verwerkersovereenkomst standaard.',
	},
]

export default function PrivacyRoute() {
	return (
		<MarketingPage
			title="Privacyverklaring"
			intro="Muziekdocent is gebouwd voor het onderwijs. Dat betekent: zo min mogelijk gegevens, alles binnen de EU, en nooit doorverkopen. Versie 1.0 — juli 2026."
		>
			<MarketingSection title="Welke gegevens verwerken we?">
				<p>
					Voor <strong>docenten</strong>: naam, school-e-mailadres en de
					klassen en oefeningen die je aanmaakt. Voor{' '}
					<strong>leerlingen</strong>: roepnaam, klas, en voortgang in de
					oefeningen (scores, XP, badges). Leerlingen hoeven geen
					e-mailadres op te geven wanneer de school inlogt via Entree
					Federatie.
				</p>
			</MarketingSection>

			<MarketingSection title="Waar staan de gegevens?">
				<p>
					Alle gegevens staan op servers in de Europese Unie (regio
					Amsterdam). Er vindt geen doorgifte plaats naar landen buiten de
					EER.
				</p>
			</MarketingSection>

			<MarketingSection title="Geen tracking, geen verkoop">
				<p>
					We gebruiken alleen strikt noodzakelijke cookies (inloggen,
					beveiliging). Geen advertentie- of tracking-cookies, geen
					profilering, en we verkopen nooit gegevens aan derden.
				</p>
			</MarketingSection>

			<MarketingSection
				id="verwerkersovereenkomst"
				title="Verwerkersovereenkomst"
			>
				<p>
					Voor scholen is een standaard verwerkersovereenkomst beschikbaar,
					opgesteld conform het privacyconvenant digitale onderwijsmiddelen
					(VO). Deze is onderdeel van elke schoollicentie. Vraag het
					document op via{' '}
					<a
						href="mailto:info@muziekdocent.nl"
						className="text-white underline underline-offset-4"
					>
						info@muziekdocent.nl
					</a>
					.
				</p>
			</MarketingSection>

			<MarketingSection title="Jouw rechten (AVG)">
				<p>
					Je hebt recht op inzage, correctie, verwijdering en export van je
					gegevens. Ingelogde gebruikers kunnen hun gegevens direct
					downloaden via hun profielinstellingen; scholen kunnen een
					volledige export opvragen. Verzoeken handelen we binnen 30 dagen
					af.
				</p>
			</MarketingSection>

			<MarketingSection title="Bewaartermijnen">
				<p>
					Gegevens van gedeactiveerde scholen worden na 90 dagen definitief
					verwijderd. Accountgegevens verwijderen we op verzoek.
				</p>
			</MarketingSection>

			<MarketingSection title="Contact">
				<p>
					Vragen over privacy? Mail{' '}
					<a
						href="mailto:info@muziekdocent.nl"
						className="text-white underline underline-offset-4"
					>
						info@muziekdocent.nl
					</a>
					. Muziekdocent AI B.V., Amsterdam.
				</p>
			</MarketingSection>
		</MarketingPage>
	)
}
